import groupBy from 'lodash/groupBy';
import { Category } from './interfaces';

const assignParentLinks = function (nodes: Category[], parent: Category | null): void {
  for (const node of nodes) {
    node.parent = parent;
    if (node.children?.length) {
      assignParentLinks(node.children, node);
    }
  }
};

export const mapCategoryTree = (categories: Category[]): Category[] => {
  if (!categories.length) {
    return [];
  }

  const categoriesByDepth = groupBy<Category>(
    categories,
    category => category.ancestorsRef?.length ?? 0
  );

  const depthArray = Object.keys(categoriesByDepth).sort((a, b) => Number(a) - Number(b));
  let previousDepthCategoriesByParentId: Record<string, Category[]> = {};

  for (let idx = depthArray.length - 1; idx >= 0; idx -= 1) {
    const depthKey = depthArray[idx];
    if (Object.keys(previousDepthCategoriesByParentId).length) {
      categoriesByDepth[depthKey] = categoriesByDepth[depthKey].map(category => {
        if (Object.keys(previousDepthCategoriesByParentId).includes(category.id)) {
          return {
            ...category,
            children: previousDepthCategoriesByParentId[category.id],
          };
        }

        return category;
      });
    }
    previousDepthCategoriesByParentId = groupBy<Category>(
      categoriesByDepth[depthKey],
      category => category.parent?.id ?? 'root'
    );
  }

  const roots = categoriesByDepth[depthArray[0]];
  assignParentLinks(roots, null);

  return roots;
};
